import Installments from "../../components/installments/installments";

function InstallmentsRoute() {
  return <Installments />;
}

export default InstallmentsRoute;
